let viewCapAcctIconLarge;
let viewCapAcctIconSmall;
let viewTransactionsModal;

export function buildAccountSummary(clientData, userData, isMAR, addedAccountSummaryListenersAlready) {
	/* This generates a pdf for all class cards: uses Regex to strip out and replace unwanted html */
	viewCapAcctIconLarge = document.getElementById('viewCapAcctIconLarge');
	viewCapAcctIconSmall = document.getElementById('viewCapAcctIconSmall');
	viewTransactionsModal = document.getElementById('viewTransactionsModal');

	// Check if account summary is explicitly enabled via flag
	const accountSummaryEnabled = clientData.flags?.show_account_summary === true;

	if (accountSummaryEnabled || !clientData.flags?.enable_dashboard) {
		viewCapAcctIconLarge.classList.remove('hidden');
		viewCapAcctIconSmall.classList.remove('hidden');
		viewCapAcctIconLarge.title = 'Account Summary';
		viewCapAcctIconSmall.title = 'Account Summary';
		document.getElementById('viewCapAcctTriggerLarge').classList.remove('modal-trigger');
		document.getElementById('viewCapAcctTriggerSmall').classList.remove('modal-trigger');
	}

	if (!addedAccountSummaryListenersAlready) {
		addedAccountSummaryListenersAlready = true;
		narrow = screen.width < 600;
		if (narrow) viewCapAcctIconSmall.addEventListener('click', (e) => renderPrintableSummary(clientData, userData, isMAR));
		else viewCapAcctIconLarge.addEventListener('click', (e) => renderPrintableSummary(clientData, userData, isMAR));
	}
}

function renderPrintableSummary(clientData, userData, isMAR) {
	// if (window.analytics) window.analytics.track('View Account Summary Button Clicked', {
	// 	userEmail: authedUser,
	// 	workspace: client
	// }); <--uncomment this if we want to track this

	M.Modal.getInstance(document.getElementById('statementWaitState')).open();
	let content = document.getElementById('shareClassDetails').innerHTML;
	content = content.replace(/ border-blue-2 active/gi, '');

	let cards = content.split('<div class="share-card');
	let classCard = {};
	let sortOrder = [];

	Object.keys(cards).forEach(function (c) {
		cards[c] = '<div class="share-card' + cards[c];
		cards[c] = cards[c].replace(/<span [\s\S]{5,50}?>Selected[\s\S]{0,10}?<\/span>/gi, '');
		cards[c] = cards[c].replace(/<p [\s\S]{10,100}?>Select[\s\S]{1,10}?<\/p>/gi, '');
		cards[c] = cards[c].replace(/<\/h5>[\s\S]{1,100}?<h5 .{5,50}?>/gi, ' - ');
		cards[c] = cards[c].replace(/<h5 /gi, '<h5 style="font-size: 18px; margin-top: 1rem; margin-bottom: 1rem;" ');
		cards[c] = cards[c].replace(/<hr /gi, '<hr style="margin-bottom: 1rem" ');
		cards[c] = cards[c].replace(/ class="text-secondary/gi, ' style="line-height: 1.8;" class="text-secondary');
		cards[c] = cards[c].replace(/<p .+?>Show schedule<\/a><\/p>/gi, '');
		cards[c] = cards[c].replace(/<div .+?>Vesting Schedule<\/div>/gi, '');
		let match = cards[c].match(/data-class="(.{1,20}?)"/i);

		if (match && isMAR) {
			classCard[match[2]] = cards[c];
			sortOrder.push(match[2]);
		} else if (match) {
			classCard[match[1]] = cards[c];
			sortOrder.push(match[1]);
		}
	});
	let cardKeys = Object.keys(classCard);
	cardKeys.sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b));

	let valueHeading = document.getElementById('valueHeading');
	let viewCapAcctModal = document.getElementById('viewCapAcctModal');
	let dateNow = moment().format('MMM D, YYYY');
	let userName = userData.user_name.replace(/_/g, ' ');

	viewCapAcctModal.innerHTML = `
        <div id="accountSummary" style="font-family: 'Source Sans Pro', sans-serif; font-size: 18px; padding: 2rem">
            <img id="brandLogo" class="responsive-img" src="${clientData.company_logo ? formatImg(clientData.company_logo, '/h_48/') : ''}">
            <div class="row mb-0">
                <div class="s12 justify-between flex items-center">
                    <h2 class="text-2xl font-bold mt-0 mb-0" style="min-width: 800px;">Account Summary <span style="font-weight: lighter; color: gray">as of ${dateNow}</span></h2>
                </div>
            </div>
            <div class="row mt-0">
                <div id="accountDetails" class="col s12 text-secondary" style="font-weight: lighter; color: gray">${userName + ' - ' + userData.userid}</div>
            </div>
            <div class="row" style="display: block; margin-top: 1rem;">${valueHeading.innerHTML}</div>
            <div>
                <div class="row">
                    <table id="userStatementsSortTable" class="highlight table-content responsive-table" style="table-layout:fixed; width: 100%;">
                        <tbody>
                        ${cardKeys
							.map(
								(key, index) =>
									`
                            <tr>
                                <td width='60%'>
                                    <div style="page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%; background: #FFFFFF; border:1px solid #E1E1E1; border-radius: 4px; padding: 1rem; margin-top: 2.5rem; padding-bottom: 1.5rem;">${classCard[key]}</div>
                                </td width='40%'>
                                <td style="vertical-align: top;">
                                    <div style="page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%;"">
                                        <img src=${clientData.equity[key] && clientData.equity[key].landingPage && clientData.equity[key].landingPage.image ? clientData.equity[key].landingPage.image.replace(/\/image\/upload\//i, '\/image\/upload\/w_200\/') : clientData.product_image.replace(/\/image\/upload\//i, '\/image\/upload\/w_200\/')} class="responsive-img mt-2" style="width: 10rem; height: 8rem; object-fit: cover; cursor: default; display: block; margin-top: 3rem; margin-left: 8rem; margin-right: auto;">
                                    </div>
                                </td>
                            </tr>
                            `
							)
							.join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;

	let Api2Pdf = require('api2pdf');
	let a2pClient = new Api2Pdf('6e053f8e-75b7-4271-a316-1981d7640681');
	let fileName = 'Account Summary for ' + userName + ' as of ' + moment().format('MM-D-YYYY') + '.pdf';
	a2pClient.chromeHtmlToPdf(viewCapAcctModal.innerHTML, { inline: false, filename: fileName }).then(function (result) {
		console.log(result);
		let request = new XMLHttpRequest();
		request.open('GET', result.FileUrl, true);
		request.responseType = 'blob';
		request.onload = function () {
			saveAs(result.FileUrl, fileName);
			M.Modal.getInstance(document.getElementById('statementWaitState')).close();
		};
		request.send();
	});
}

export async function generateAmortizationSchedule(nrid, transactions, opts = {}) {
	const mode = opts.mode || 'html';

	let thisTrans = transactions.find((t) => t.nrid == nrid);
	// console.log(thisTrans);

	let amorTable;
	let now = Date.now() / 1000;
	let start = thisTrans.date;
	let qty = Number(thisTrans.quantity);
	let pv = Number(thisTrans.sharePrice);
	let gross = Number(thisTrans.referencePrice);
	let its2022 = moment.unix(start).year() == 2022;
	let its2025 = moment.unix(start).year() == 2025;

	if (isBOH) {
		const loanMatch = thisTrans.notes.match(/\(\s*(NP|NR)(?:-([a-zA-Z0-9]+))?[^$0-9]*\$?([\d,\.]+)/);
		if (!loanMatch) {
			amorTable = `<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1">No data to display.</div>`;
		} else {
			// 🔹 AFR rate helper — AFR in effect ON the given date (keys in clientData.interest_rates)
			function getAFRRateFromClientData(dateLike) {
				const m = moment(dateLike);
				const rates = Object.entries(clientData.interest_rates || {})
					.map(([effective, rate]) => ({ effective, rate: Number(rate) / 100 }))
					.sort((a, b) => moment(b.effective).diff(moment(a.effective)));
				const found = rates.find((r) => m.isSameOrAfter(moment(r.effective, 'YYYY-MM-DD'), 'day'));
				const rate = found ? found.rate : rates.length ? rates[rates.length - 1].rate : 0.0568;
				return Math.round(rate * 10000) / 10000; // round to 4dp to avoid float tails
			}

			// 🔹 Shared helper: build paymentDates array (reuses your legacy vs synthesize behavior)
			function buildPaymentDates({ pattern, numPayments, startDate, payments }) {
				function parseDateLocal(dateStr) {
					const [year, month, day] = dateStr.split('-').map(Number);
					return new Date(year, month - 1, day); // JS months are 0-based
				}
				// Only count legacy dates that are actually on/after this loan's start date
				let legacyDates = Object.keys(payments)
					.map(parseDateLocal)
					.filter((d) => d >= startDate)
					.sort((a, b) => a - b);

				let futureDates = [];

				// Only synthesize future dates if needed
				let paymentDates;
				if (legacyDates.length >= numPayments) {
					paymentDates = legacyDates.slice(0, numPayments);
				} else {
					let pDate = new Date(2025, 3, 15); // Apr 15, 2025
					for (let i = 0; futureDates.length + legacyDates.length < numPayments && i < 40; i++) {
						const clone = new Date(pDate.getTime());
						const dateISO = clone.toISOString().slice(0, 10);
						if (clone >= startDate && !payments[dateISO]) futureDates.push(clone);
						pDate.setMonth(pDate.getMonth() + 6);
					}
					paymentDates = [...legacyDates, ...futureDates]
						.sort((a, b) => a - b) // Sort oldest → newest
						.slice(0, numPayments); // Only keep required payments
				}
				return paymentDates;
			}

			// ---------- Minimal Excel-style ACT/365 helpers ----------
			function daysIncUTC(a, b) {
				// Excel-like inclusive day count: DAYS(end,start)+1
				const Au = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
				const Bu = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
				return Math.max(0, Math.floor((Bu - Au) / 86400000) + 1);
			}
			function firstAfrChangeInside(fromDate, toDate) {
				const entries = Object.entries(clientData.interest_rates || {})
					.map(([d, r]) => new Date(d + 'T00:00:00Z'))
					.sort((a, b) => a - b);
				for (const eff of entries) {
					// strictly inside (fromDate, toDate] to match sheet examples
					if (eff > fromDate && eff <= toDate) return eff;
				}
				return null;
			}

			// Daily simple interest for a single period, ACT/365, with a single AFR split if needed.
			function accrueDailyInterest(balance, fromDate, toDate, { basis = 'ACT/365', isShortSchedule = false } = {}) {
				if (balance <= 0 || !(fromDate instanceof Date) || !(toDate instanceof Date) || toDate < fromDate) return 0;

				// Short schedules: 7.5% ONLY for loans that started before 10/01/2023
				if (isShortSchedule && Number(thisTrans.date) <= 1696118400) {
					// 2023-10-01 00:00:00 UTC
					const denom = basis === 'ACT/365' ? 365 : 360;
					const d = daysIncUTC(fromDate, toDate);
					return Math.round(balance * (0.075 * (d / denom)) * 100) / 100;
				}

				// Excel-style split on AFR effective date if it falls inside the period
				const change = firstAfrChangeInside(fromDate, toDate);
				const denom = basis === 'ACT/365' ? 365 : 360;

				if (change) {
					const denom = basis === 'ACT/365' ? 365 : 360;

					// Old rate THROUGH the change date (inclusive)
					const changeLocal = new Date(change.getUTCFullYear(), change.getUTCMonth(), change.getUTCDate());
					const nextDay = new Date(changeLocal);
					nextDay.setDate(nextDay.getDate() + 1);

					const oldRate = getAFRRateFromClientData(fromDate);
					const newRate = getAFRRateFromClientData(nextDay);

					const d1 = daysIncUTC(fromDate, changeLocal); // inclusive
					const d2 = daysIncUTC(nextDay, toDate); // inclusive

					const val = balance * (oldRate * (d1 / denom) + newRate * (d2 / denom));
					return Math.round(val * 100) / 100;
				} else {
					// single AFR over the whole period; pick rate in effect on period end (matches client sheets)
					const rate = getAFRRateFromClientData(toDate);
					const d = daysIncUTC(fromDate, toDate);
					return Math.round(balance * (rate * (d / denom)) * 100) / 100;
				}
			}

			// 🔹 New flat principal schedule (post-Oct 2025), but STILL honors overrides
			function buildFlatPrincipalSchedule({ loanAmount, numPayments, startDate, paymentDates, payments, isShortSchedule }) {
				const fixedPrincipal = Math.round((loanAmount / numPayments) * 100) / 100;
				let balance = loanAmount;
				let d = new Date(startDate);
				let schedule = [];

				for (let i = 0; i < numPayments; i++) {
					const currentDate = paymentDates[i];
					if (!currentDate) {
						console.error('Missing payment date', { i, paymentDates, startDate, pattern, numPayments });
						break;
					}
					const dateStr = currentDate.toISOString().slice(0, 10);

					// 🔸 Daily interest from previous payment date → current date (ACT/365 default)
					// const periodStart = i === 0 ? new Date(startDate) : new Date(paymentDates[i - 1] || d);
					// NEW CODE 4-14-2026
					let periodStart;
					if (i === 0) {
						// First period: start on the loan date
						periodStart = new Date(startDate);
					} else {
						// Subsequent periods: start the day after the prior payment
						periodStart = new Date(paymentDates[i - 1] || d);
						periodStart.setDate(periodStart.getDate() + 1);
					}

					const periodEnd = currentDate;
					let interest = accrueDailyInterest(balance, periodStart, periodEnd, {
						basis: 'ACT/365', // client prefers ACT/365
						isShortSchedule,
					});

					// default: flat principal
					let thisPrincipal = i === numPayments - 1 ? balance : fixedPrincipal;

					// 🔹 Apply overrides if any (factor | principal)
					if (payments[dateStr]) {
						const parts = payments[dateStr].split('|');
						const factor = parseFloat(parts[0]) || 0;
						const overridePrincipal = parts[1] !== undefined ? Number(parts[1]) : null;

						// If admin supplies a factor, it overrides the computed daily interest
						if (!isNaN(factor) && factor !== 0) {
							interest = Math.round(balance * factor * 100) / 100;
						}

						if (overridePrincipal !== null) {
							thisPrincipal = overridePrincipal;

							// 🔍 Detect skipped principal (explicit 0) and extend schedule
							if (overridePrincipal === 0) {
								numPayments++;
								let nextDate = new Date(currentDate);
								nextDate.setMonth(nextDate.getMonth() + 6);
								paymentDates.push(nextDate);
							}
						}
					}

					const payment = Math.round((thisPrincipal + interest) * 100) / 100;
					balance = Math.round((balance - thisPrincipal) * 100) / 100;

					schedule.push({
						number: i + 1,
						date: new Intl.DateTimeFormat('en-US').format(currentDate),
						stamp: Math.floor(currentDate.getTime() / 1000),
						payment: payment.toFixed(2),
						interest: interest.toFixed(2),
						principal: thisPrincipal.toFixed(2),
						balance: balance.toFixed(2),
					});

					// increment default date if not from paymentDates
					d.setMonth(d.getMonth() + 1);
				}
				return schedule;
			}

			// 🔹 Legacy TValue-style schedule (pre-Oct 2025), now using per-period AFR for non-override rows
			function buildLegacySchedule({ loanAmount, numPayments, startDate, paymentDates, payments, today, isShortSchedule }) {
				let schedule = [];
				let balance = loanAmount;
				let principalPayment = (100 * (loanAmount / numPayments)) / 100; // round to pennies
				let previousDate = startDate;
				let effectiveRate = 0;

				for (let i = 0; i < numPayments; i++) {
					if (balance <= 0) break;
					const currentDate = paymentDates[i];
					const dateStr = currentDate.toISOString().slice(0, 10); // e.g., "2023-10-15"
					let thisPrincipal = principalPayment;
					let interest = 0;

					if (payments[dateStr]) {
						const parts = payments[dateStr].split('|');
						const factor = parseFloat(parts[0]) || 0;
						const overridePrincipal = parts[1] !== undefined ? Number(parts[1]) : null;

						// 🔹 Use stored historical interest factor
						interest = Math.round(balance * factor * 100) / 100;

						if (overridePrincipal !== null) {
							thisPrincipal = overridePrincipal;

							// adjust up principal payment - seems crazy...
							if (i == 0) principalPayment = (100 * ((loanAmount - overridePrincipal) / (numPayments - i - 1))) / 100;

							// 🔍 Detect skipped principal (explicit 0) and extend schedule
							if (overridePrincipal === 0) {
								numPayments++;
								let nextDate = new Date(paymentDates[paymentDates.length - 1]); // last known date
								nextDate.setMonth(nextDate.getMonth() + 6);
								paymentDates.push(nextDate);
							}
						}
					} else {
						// 🔸 Use daily simple interest (ACT/365) by default
						const periodStart =
							i === 0
								? new Date(startDate) // first period starts ON loan date (inclusive)
								: new Date(previousDate.getFullYear(), previousDate.getMonth(), previousDate.getDate() + 1);
						const periodEnd = currentDate;

						// 👉 TValue stub override: first period only for NP/NR starting 1/1/2025, due ~4/14–4/15
						const patternSuffix = loanMatch[2] || null;
						const isPlainNP = loanType === 'NP' && !patternSuffix; // ✅ override
						const isPlainNR = loanType === 'NR' && !patternSuffix; // ✅ override
						const isNR6 = loanType === 'NR' && patternSuffix === '6'; // ✅ override
						const isNR14 = loanType === 'NR' && patternSuffix === '14'; // ✅ override
						const isNP14 = loanType === 'NP' && patternSuffix === '14'; // ❌ NO override

						const isFirstStub = i === 0;
						const isJan1_2025 = startDate.getFullYear() === 2025 && startDate.getMonth() === 0 && startDate.getDate() === 1;
						const isMidApril = currentDate.getMonth() === 3 && (currentDate.getDate() === 14 || currentDate.getDate() === 15);

						if (!isNP14 && (isPlainNP || isPlainNR || isNR6 || isNR14) && isFirstStub && isJan1_2025 && isMidApril) {
							// TValue-style first stub (calibrated)
							const annualRate = getAFRRateFromClientData(startDate); // 0.0568 on 2025-01-01
							const monthsInPeriod = 3.460860526;
							const effectiveRate = Math.pow(1 + annualRate / 12, monthsInPeriod) - 1;
							interest = Math.round(balance * effectiveRate * 100) / 100;
						} else {
							interest = accrueDailyInterest(balance, periodStart, periodEnd, {
								basis: 'ACT/365',
								isShortSchedule,
							});
						}
					}

					let payment = Math.round((interest + thisPrincipal) * 100) / 100;

					// Adjust final payment to force balance to zero
					if (i === numPayments - 1) {
						// Final row: keep the daily interest we already computed for [prev+1 .. current]
						thisPrincipal = balance; // pay off all remaining principal
						payment = Math.round((interest + thisPrincipal) * 100) / 100;
						balance = 0;
					} else {
						// 🔸 Normal balance reduction for fixed principal
						balance = Math.round((balance - thisPrincipal) * 100) / 100;
					}

					schedule.push({
						number: i + 1,
						date: new Intl.DateTimeFormat('en-US').format(currentDate),
						stamp: Math.floor(currentDate.getTime() / 1000),
						payment: payment.toFixed(2),
						interest: interest.toFixed(2),
						principal: thisPrincipal.toFixed(2),
						balance: balance.toFixed(2),
					});

					// Update previous date for next iteration
					previousDate = currentDate;
				}

				return schedule;
			}

			const loanType = loanMatch[1]; // "NP" or "NR"
			const pattern = loanMatch[2] || '6'; // "10dd"
			let numPayments = Number(pattern.replace(/[^.\d]/g, ''));
			const loanAmount = Number(loanMatch[3].replace(/[^.\d]/g, ''));

			// NOTE: daysInYear left for reference; not directly used after refactor
			const daysInYear = 360; // TValue likely uses 360-day year for daily interest
			const compoundingPeriodsPerYear = 12; // Monthly compounding
			const today = new Date();

			const startDate = new Date(start * 1000);
			const isShortSchedule = numPayments <= 6;

			// Build payment dates once (shared by both schedule builders)
			const payments = clientData.payment_patterns[pattern] || {};
			const paymentDates = buildPaymentDates({ pattern, numPayments, startDate, payments });

			// Cutover: loans starting on/after Oct 1, 2025 → flat-principal baseline (still with overrides, now daily interest)
			const cutoffDate = new Date(2025, 9, 1); // October 1, 2025

			let schedule = [];
			if (startDate >= cutoffDate) {
				schedule = buildFlatPrincipalSchedule({
					loanAmount,
					numPayments,
					startDate,
					paymentDates,
					payments,
					isShortSchedule,
				});
			} else {
				schedule = buildLegacySchedule({
					loanAmount,
					numPayments,
					startDate,
					paymentDates,
					payments,
					today,
					isShortSchedule,
				});
			}

			// ⛳ Totals recompute from schedule (paid vs due by "now")
			let totalIntDue = 0,
				totalIntPaid = 0,
				totalPrinDue = 0,
				totalPrinPaid = 0;
			for (const row of schedule) {
				if (row.stamp < now) {
					totalIntPaid += Number(row.interest);
					totalPrinPaid += Number(row.principal);
				} else {
					totalIntDue += Number(row.interest);
					totalPrinDue += Number(row.principal);
				}
			}

			// Accrued interest (payoff) — DAILY from last paid date → today (ACT/365 by default)
			let payoffStartDate = [...paymentDates].reverse().find((date) => date < today) || startDate;
			if (payoffStartDate) {
				payoffStartDate = new Date(payoffStartDate);
				payoffStartDate.setDate(payoffStartDate.getDate() + 1);
			}
			let accruedInterest = accrueDailyInterest(totalPrinDue, payoffStartDate, today, { basis: 'ACT/365', isShortSchedule });
			// If you must keep the historic fudge factor, uncomment next line:
			// accruedInterest = accruedInterest * 0.998311254;

			const payOffAmount = totalPrinDue + Math.round(accruedInterest * 100) / 100;

			// For snapshot: approximate ending balance from schedule (fallback to original loan)
			const endingBalance = schedule.length ? Number(schedule[schedule.length - 1].balance) : loanAmount;

			const entityName = thisTrans.shareClass == 'BMI' ? 'BMI' : 'Bohler ' + thisTrans.shareClass;
			const description = `${qty.toLocaleString()} shares (${(qty / 10).toLocaleString()}% of ${entityName}) at ${Number(thisTrans.sharePrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} per share`;

			if (mode === 'snapshot') {
				// Month window (local)
				const monthStart = moment().startOf('month').startOf('day').unix();
				const monthEnd = moment().endOf('month').endOf('day').unix();

				// Prefer a payment IN this month; if none, roll to the first AFTER this month.
				let upcoming = schedule.find((r) => r.stamp >= monthStart && r.stamp <= monthEnd);
				if (!upcoming) upcoming = schedule.find((r) => r.stamp > monthEnd);

				// No upcoming at all → finished or irrelevant → skip from report
				if (!upcoming) return null;

				const currentTotalPayment = Number(upcoming.payment);
				const principalBalanceAfterCurrentPayment = Number(upcoming.balance);
				const finalPaymentDate = paymentDates?.[paymentDates.length - 1] || null;
				const purchaseOrSale = /sale/i.test(thisTrans?.eventType || thisTrans?.description || '') ? 'Sale' : 'Purchase';
				const loanDate = moment.unix(Number(start)).toDate();

				return {
					company: thisTrans.shareClass,
					purchaseOrSale,
					description,
					loanDate,
					originalLoan: loanAmount,
					currentTotalPayment,
					principalBalanceAfterCurrentPayment,
					finalPaymentDate: finalPaymentDate ? new Date(finalPaymentDate) : null,
					loanType,
				};
			}

			function getCurrentRateInfo(refDate = new Date()) {
				const entries = Object.entries(clientData.interest_rates || {})
					.map(([d, r]) => ({ eff: new Date(d + 'T00:00:00'), pct: Number(r) })) // pct as e.g. 5.68
					.sort((a, b) => a.eff - b.eff);
				let match = entries.filter((e) => e.eff <= refDate).pop();
				if (!match && entries.length) match = entries[0];
				return match || null; // {eff: Date, pct: 5.68}
			}

			const shortPrime = isShortSchedule && Number(thisTrans.date) <= 1696118400; // pre-2023-10-01
			let currentRateLabel;
			if (shortPrime) {
				currentRateLabel = '7.00% Prime (effective 10/29/2025).'; //" short schedule; ACT/365)";
			} else {
				const ri = getCurrentRateInfo(new Date());
				currentRateLabel = ri
					? `${ri.pct.toFixed(2)}% AFR (effective ${moment(ri.eff).format('M/D/YYYY')}).` // ACT/365)`
					: 'N/A';
			}

			// ---------- Rendering (unchanged structure) ----------
			amorTable = `
                <div>
                    <p class="text-xs mt-0 mb-0">${thisTrans.receiverName}, January ${moment.unix(start).format('YYYY')}:&nbsp;${description}.</p>
                    <p class="text-xs mt-0 mb-0">Amount due if paid off in full today: Principal ${totalPrinDue.toLocaleString('en-US', usd)} + Accrued Interest ${accruedInterest.toLocaleString('en-US', usd)} = <span class="font-bold">${payOffAmount.toLocaleString('en-US', usd)}</span></p>
                    <p class="text-xs mt-0 mb-4">Current interest rate: ${currentRateLabel}</p>
                </div>
                <table id="amortizationSortTable" class="card highlight table-content">
                    <thead>
                        <tr>
                            <th class="text-xs p-05 right-align">#</th>
                            <th class="text-xs p-05 right-align">Date</th>
                            <th class="text-xs p-05 right-align">Payment</th>
                            <th class="text-xs p-05 right-align">Interest</th>
                            <th class="text-xs p-05 right-align">Principal</th>
                            <th class="text-xs p-05 right-align">Balance</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

			amorTable += `
                <tr>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 center-align"><span>Loan</span></p>
                    </td>
                    <td class="text-xs text-secondary p-0">
                        <p class="mb-0 mt-0 right-align"><span>${new Date(Number(start) * 1000).toLocaleDateString('en-US')}</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span></span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span></span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span></span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${loanAmount.toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
            `;
			schedule.forEach((sched) => {
				amorTable += `
                    <tr>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0" data-sort='${sched.stamp}'>
                            <p class="mb-0 mt-0 center-align"><span>${sched.number}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0" data-sort='${sched.stamp}'>
                            <p class="mb-0 mt-0 right-align"><span>${sched.date}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.payment).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.interest).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.principal).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.balance).toLocaleString('en-US', usd)}</span></p>
                        </td>
                    </tr>
                `;
			});

			amorTable += `
                </tbody>
                <tfoot>
                    <tr>
                        <td class="text-xs text-secondary border-t-2 p-0" colspan="2">
                            <p class="ml-6 mt-0 mb-0 left-align"><span>Amounts Paid Already</span></p>
                        </td>
                        <td class="text-xs text-secondary border-t-2 p-0">
                            <p class="mt-0 mb-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs text-secondary border-t-2 p-0">
                            <p class="mt-0 mb-0 mr-4 right-align"><span>${totalIntPaid.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs text-secondary border-t-2 p-0">
                            <p class="mt-0 mb-0 mr-4 right-align"><span>${totalPrinPaid.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-xs p-0" colspan="2">
                            <p class="ml-6 mb-0 mt-0 left-align"><span>Amounts To Be Paid</span></p>
                        </td>
                        <td class="text-xs p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${totalIntDue.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${totalPrinDue.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-xs font-bold p-0" colspan="2">
                            <p class="ml-6 mb-0 mt-0 left-align"><span>TOTAL</span></p>
                        </td>
                        <td class="text-xs font-bold p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid + totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs font-bold p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalIntPaid + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs font-bold p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalPrinDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
                </table>
            `;

			// not used (yet...)
			function getFractionalMonths(start, end) {
				let yearsDiff = end.getFullYear() - start.getFullYear();
				let monthsDiff = end.getMonth() - start.getMonth();
				let totalMonths = yearsDiff * 12 + monthsDiff;

				// Get the number of days in the start month
				let startOfNextMonth = new Date(start.getFullYear(), start.getMonth() + 1, 1);
				let daysInStartMonth = (startOfNextMonth - start) / (1000 * 60 * 60 * 24);

				// Compute fractional month component
				let dayFraction = (end.getDate() - start.getDate()) / daysInStartMonth;

				// Adjust for mid-month start and end cases
				if (start.getDate() > 1 && end.getDate() > 1) {
					dayFraction = (end.getDate() - start.getDate()) / 30; // Approximate 30-day months
				}

				return totalMonths + dayFraction;
			}
		}
	} else {
		// JM Search
		let finance = new Finance();
		let pmt = gross / 40;
		let rate = finance.RATE(40, -pmt, pv);
		console.log('Annual Rate: ' + rate * 400);
		let amort = {};
		let balance = pv * qty;
		let totalIntDue = 0;
		let totalPrinDue = 0;
		let totalIntPaid = 0;
		let totalPrinPaid = 0;
		let scheduledPmt = -finance.PMT(0.0181 / 4, 40, pv) * qty;
		console.log('Sceduled Payment: ' + scheduledPmt);

		let eventUserData;
		if (pn.includes('/admin/users/edit')) eventUserData = JSON.parse(sessionStorage.getItem('shareholder.Data'));
		else eventUserData = JSON.parse(sessionStorage.getItem('user.Data'));

		for (let i = 1; i <= 40; i++) {
			let date = moment.unix(start).add(3 * i, 'months');
			let dateString = date.format('MMM-YY');
			let timeStamp = Date.parse(date) / 1000;
			let ppmt = -finance.PPMT(rate, i, 40, pv) * qty;
			let ipmt = -finance.IPMT(rate, i, 40, pv) * qty;
			// handle non-standard 2022 amortization
			if (its2022) {
				ipmt = (balance * 0.0181) / 4;
				ppmt = scheduledPmt - ipmt;
				// this feels incorrect as it skips the last interest payment
				if (scheduledPmt >= balance) {
					ppmt = balance;
					ipmt = 0;
				}
				balance -= ppmt;
			}
			let ttl = ppmt + ipmt;
			if (date > moment()) {
				totalIntDue += ipmt;
				totalPrinDue += ppmt;
			} else {
				totalIntPaid += ipmt;
				totalPrinPaid += ppmt;
			}
			amort[i] = { number: i, stamp: timeStamp, date: dateString, total: ttl, principal: ppmt, interest: ipmt };
		}
		// console.log(amort);

		amorTable = `
            <div>
                ${
					thisTrans.sender == eventUserData.userid
						? `
                    <p class="text-xs mt-0 mb-0">Sold to ${thisTrans.receiverName}, January ${moment.unix(start).format('YYYY')}:&nbsp;${qty.toLocaleString()} shares (${qty / 10000}% of JMS) at ${Number(thisTrans.sharePrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} per share.</p>
                `
						: `
                    <p class="text-xs mt-0 mb-0">Purchased from ${thisTrans.senderName}, January ${moment.unix(start).format('YYYY')}:&nbsp;${qty.toLocaleString()} shares (${qty / 10000}% of JMS) at ${Number(thisTrans.sharePrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} per share.</p>
                `
				}
                ${
					its2022
						? `
                    <p class="text-xs mt-0">Assuming 39 equal payments and one final payment over 10 years, interest rate = 1.81%<p>
                `
						: `
                    <p class="text-xs mt-0">Assuming 40 equal payments over 10 years, implied compound annual interest rate = ${(rate * 400).toLocaleString('en-US', m4)}%<p>
                `
				}
            </div>
            <table id="amortizationSortTable" class="card highlight table-content">
                <thead>
                    <tr>
                        <th class="text-xs p-05 right-align">&emsp;#&emsp;&emsp;Payment</th>
                        <th class="text-xs p-05 right-align">Amount</th>
                        <th class="text-xs p-05 right-align">Principal</th>
                        <th class="text-xs p-05 right-align">Interest</th>
                    </tr>
                </thead>
                <tbody>
            `;
		Object.keys(amort).forEach((a) => {
			amorTable += `
                <tr>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0" data-sort='${amort[a].stamp}' style="width:25%">
                        <p class="mb-0 mt-0 center-align"><span>${amort[a].number}&ensp;&ensp;<span class="text-white">|</span>&ensp;&ensp;${amort[a].date}</span></p>
                    </td>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(amort[a].total).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(amort[a].principal).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(amort[a].interest).toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
            `;
		});

		amorTable += `
            </tbody>
            <tfoot>
                <tr>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="ml-6 mt-0 mb-0 left-align"><span>Amounts Paid Already</span></p>
                    </td>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="mt-0 mb-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="mt-0 mb-0 mr-4 right-align"><span>${totalPrinPaid.toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="mt-0 mb-0 mr-4 right-align"><span>${totalIntPaid.toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
                <tr>
                    <td class="text-xs p-0">
                        <p class="ml-6 mb-0 mt-0 left-align"><span>Amounts To Be Paid</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${totalPrinDue.toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${totalIntDue.toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
                <tr>
                    <td class="text-xs font-bold p-0">
                        <p class="ml-6 mb-0 mt-0 left-align"><span>TOTAL</span></p>
                    </td>
                    <td class="text-xs font-bold p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid + totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs font-bold p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalPrinDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs font-bold p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalIntPaid + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
            </tfoot>
            </table>
        `;
	}

	document.getElementById('amortizationTable').innerHTML = amorTable;
	let table = document.getElementById('amortizationSortTable');
	if (table) {
		let sort = new Tablesort(table, { descending: false });
	}

	let amortizationModal = document.getElementById('amortizationModal');
	// M.Modal.getInstance(amortizationModal).options.dismissible = false;
	// M.Modal.getInstance(viewTransactionsModal).close();
	if (!viewTransactionsModal) viewTransactionsModal = document.getElementById('viewTransactionsModal');
	if (viewTransactionsModal) viewTransactionsModal.classList.add('hidden');
	M.Modal.getInstance(amortizationModal).open();
	amortizationModal.scrollTo(0, scroll);
	document.getElementById('closeAmortization').addEventListener('click', function (e) {
		M.Modal.getInstance(amortizationModal).close();
		if (viewTransactionsModal) viewTransactionsModal.classList.remove('hidden');
	});
	if (window.analytics)
		window.analytics.track('Viewed Amortization', {
			userEmail: authedUser,
			workspace: client,
			userId: userData.userid,
		});
}

export async function generateLoansReport(transactions, adminReport = false) {
	const headers = ['Company', 'Purchase or Sale', 'Description', 'Loan Date', 'Original Loan', 'Current Payment', 'Principal Balance', 'Final Payment Date'];

	// CSV escape (keep only for CSV fallbacks, NOT for HTML tables)
	const esc = (v) => {
		if (v === null || v === undefined) return '';
		const s = String(v);
		return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
	};
	// HTML escape (for DOM tables → Excel). Do NOT add quotes.
	const html = (v) => {
		if (v === null || v === undefined) return '';
		const s = String(v);
		return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	};

	const fmtDate = (d) => (d instanceof Date && !isNaN(d) ? moment(d).format('MM/DD/YYYY') : '');
	const fmtNum = (n) => (n === null || n === undefined || isNaN(n) ? '' : Number(n).toLocaleString('en-US', m2));

	// Filter "loan-ish" transactions (your original regex)
	const loans = (transactions || []).filter((t) => /\(\s*(NP|NR)(-\d+)?[^)]*\)/.test(t.notes || ''));

	// Sort (newest first; if you also want by size, do that before)
	loans.sort((a, b) => Number(b.date) - Number(a.date));

	// Build rows into two buckets
	const rowsNP = []; // Notes Payable
	const rowsNR = []; // Notes Receivable

	for (const t of loans) {
		const s = await generateAmortizationSchedule(t.nrid, loans, { mode: 'snapshot' });
		if (!s) continue;

		// NOTE: For HTML tables we do NOT CSV-escape. We format, then HTML-escape in the renderer.
		const rowRaw = [
			s.company,
			s.loanType == 'NP' ? 'Purchase' : 'Sale',
			s.description,
			fmtDate(s.loanDate),
			fmtNum(s.originalLoan),
			fmtNum(s.currentTotalPayment),
			fmtNum(s.principalBalanceAfterCurrentPayment),
			fmtDate(s.finalPaymentDate),
		];
		const type = s && s.loanType ? s.loanType : (t.notes || '').match(/\(\s*(NP|NR)/)?.[1] || 'NP';

		if (type === 'NR') rowsNR.push(rowRaw);
		else rowsNP.push(rowRaw);
	}

	// Admin report: return both buckets (no headers)
	if (adminReport) {
		return { NP: rowsNP, NR: rowsNR };
	}

	// ---------- HTML tables for your exporter ----------
	function buildHtmlTable(id, title, hdrs, rows) {
		const thead = `<thead><tr>${hdrs.map((h) => `<th class="text-xs p-05 right-align">${html(h)}</th>`).join('')}</tr></thead>`;
		const tbody = `<tbody>${rows.map((r) => `<tr>${r.map((c) => `<td class="text-xs p-0">${html(c)}</td>`).join('')}</tr>`).join('')}</tbody>`;
		return `
            <h4 style="margin:8px 0">${html(title)}</h4>
            <table id="${id}" class="card highlight table-content" aria-label="${html(title)}">
                ${thead}
                ${tbody}
            </table>
        `;
	}

	const hasNP = rowsNP.length > 0;
	const hasNR = rowsNR.length > 0;

	let userName = userData.user_name;
	if (pn.includes('/users/edit')) {
		if (!shareholderData) shareholderData = JSON.parse(sessionStorage.getItem('shareholder.Data'));
		userName = shareholderData.user_name;
	}
	const dateTag = moment().format('YYYY-MM-DD');
	const outFile = `${userName} Loans Summary dated ${dateTag}.csv`; // match your example’s extension

	// 🚦 Nothing to export? Alert and bail.
	if (!hasNP && !hasNR) {
		alert('No current Notes Payable or Notes Receivable payments to export.');
		return;
	}

	// Build one hidden container with up to two tables
	const containerId = 'loan-report-export';
	let container = document.getElementById(containerId);
	if (!container) {
		container = document.createElement('div');
		container.id = containerId;
		container.style.display = 'none';
		document.body.appendChild(container);
	}

	// Assign fixed IDs that we’ll pass to export_table_to_excel
	const npId = 'notesPayableTable';
	const nrId = 'notesReceivableTable';

	container.innerHTML = `
        ${hasNP ? buildHtmlTable(npId, 'Notes Payable', headers, rowsNP) : ''}
        ${hasNR ? buildHtmlTable(nrId, 'Notes Receivable', headers, rowsNR) : ''}
    `;

	// Build the pipe-separated id list (only include tables that exist)
	const idList = [hasNP ? npId : null, hasNR ? nrId : null].filter(Boolean).join('|');

	// 🔸 Call your exporter EXACTLY as required
	export_table_to_excel(idList, outFile);
}
